__turbopack_context__.v({
  "BlueGreen": "wETl8a_BlueGreen",
  "Highlighted": "wETl8a_Highlighted",
  "PinkBlue": "wETl8a_PinkBlue",
  "PinkOrange": "wETl8a_PinkOrange",
  "PinkPurple": "wETl8a_PinkPurple",
  "Root": "wETl8a_Root",
  "SlideShowButtons": "wETl8a_SlideShowButtons",
  "SlideShowIndicator": "wETl8a_SlideShowIndicator",
  "SlideShowIndicatorContainer": "wETl8a_SlideShowIndicatorContainer",
  "Visible": "wETl8a_Visible",
  "White": "wETl8a_White",
});
